export default __webpack_public_path__ + "locales/az/Files.json?hash=7836a64735855398153cd28572d84e0b";